import apiClient from '@/services/apiClient';

const B = '/purchase-requisitions';
const d = (p) => p.then((r) => r.data);

export const prApi = {
  list: (params = {}) => d(apiClient.get(B, { params })).then((r) => r.prs || []),
  get: (id) => d(apiClient.get(`${B}/${id}`)),
  create: (body) => d(apiClient.post(B, body)),
  update: (id, body) => d(apiClient.patch(`${B}/${id}`, body)),
  post: (id) => d(apiClient.post(`${B}/${id}/post`)),
  cancel: (id, reason) => d(apiClient.post(`${B}/${id}/cancel`, { reason })),
  close: (id, reason) => d(apiClient.post(`${B}/${id}/close`, { reason })),
  addItem: (id, body) => d(apiClient.post(`${B}/${id}/items`, body)),
  updateItem: (itemId, body) => d(apiClient.patch(`${B}/items/${itemId}`, body)),
  deleteItem: (itemId) => d(apiClient.delete(`${B}/items/${itemId}`)),
  openItems: (params = {}) => d(apiClient.get(`${B}/open-items`, { params })).then((r) => r.items || []),
  overdue: () => d(apiClient.get(`${B}/overdue`)),
  fgOptions: (params) => d(apiClient.get(`${B}/fg/options`, { params })),
  fgLookup: (barcode) => d(apiClient.get(`${B}/fg/lookup`, { params: { barcode } })),
  fgSummary: () => d(apiClient.get(`${B}/fg-summary`)).then((r) => r.fgs || []),
  pendingByFg: (fgs, excludePrId) => d(apiClient.get(`${B}/pending-by-fg`, { params: { fg_names: fgs.join(','), exclude_pr_id: excludePrId || undefined } }))
    .then((r) => r.pending || {}),
  sections: () => d(apiClient.get('/purchase-orders/sections/list')).then((r) => (r.sections || []).filter((s) => s.section_name)),
  uploadPhotos: (files) => {
    const fd = new FormData();
    for (const f of files) fd.append('files', f);
    return d(apiClient.post('/purchase-orders/photos/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }));
  },
};

export const prErr = (e, fallback = 'Something went wrong') => {
  const det = e?.response?.data?.detail;
  return typeof det === 'string' ? det : fallback;
};

export const PR_STATUS = {
  DRAFT: ['Draft', 'bg-slate-100 text-slate-700 border-slate-300'],
  OPEN: ['Open for POs', 'bg-blue-100 text-blue-700 border-blue-300'],
  PARTLY_ORDERED: ['Partly ordered', 'bg-amber-100 text-amber-800 border-amber-300'],
  FULLY_ORDERED: ['Fully ordered', 'bg-green-100 text-green-700 border-green-300'],
  CLOSED: ['Balance closed', 'bg-gray-100 text-gray-700 border-gray-300'],
  CANCELLED: ['Cancelled', 'bg-red-100 text-red-700 border-red-300'],
};

export const fmtQty = (n) => Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 3 });

export const fgText = (it) => [it.design_name, it.fg_shade, it.fg_size, it.fg_description].filter(Boolean).join(' · ');

export const unitNote = (units = []) => (units.length > 1 ? 'mixed units' : units[0] || '');
